import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'rl-toggle-content',
  templateUrl: './toggle-content.component.html',
  styleUrls: ['./toggle-content.component.scss'],
  changeDetection : ChangeDetectionStrategy.OnPush
})
export class ToggleContentComponent{

  @Input() title : string;
  @Input() showContent? : boolean = false;
  @Output() onSearch? : EventEmitter<string> = new EventEmitter<string>();

  showSearch : boolean = false;

  constructor(private ref: ChangeDetectorRef) { }

  toggle(){
    this.showContent = !this.showContent;
    this.ref.detectChanges();
  }

}
